import { Dropdown, Menu } from "antd";
import { RecursiveMenu } from "../../layouts/RecursiveMenu";

export const DropdownPopup = ({ children, menu }) => (
  <Dropdown overlay={<Menu>{RecursiveMenu(menu)}</Menu>}>{children}</Dropdown>
);
